
import { sendAli } from '~/utils/send-ali';

import { mapGetters } from "vuex";
import {getUserInfoAPI, getUserKeyAPI} from "~/api";
import {ResponseCode} from "~/constants";
import {eventBus} from "~/utils/eventBus";
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

// 在组件外部定义缓存变量，它们在组件销毁后依然存在
let cachedSegmenter = null;
let initializationPromise = null;

export default {
  name: 'AIVirtualTryOn',
  head() {
    return {
      title: this.$t('indexTryTattooPage.pageTitle'),
      meta: [
        { hid: "description", name: "description", content: this.$t('indexTryTattooPage.pageDescription') },
      ],
      link: [
        { rel: 'stylesheet', href: "https://remaker.ai/userspace/saasbox/seo-html-tool/seo-html-tool-new.css" },
        { rel: 'stylesheet', href: "https://remaker.ai/userspace/saasbox/seo-html-tool/tools.css" },
        {
          rel: "canonical",
          href: `https://remaker.ai${this.localePath({
            path: "/tattoo-simulator/",
          })}`,
        },
        {
          rel: "alternate",
          hreflang: "en",
          href: "https://remaker.ai/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "ja",
          href: "https://remaker.ai/jp/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "ko",
          href: "https://remaker.ai/kr/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "de",
          href: "https://remaker.ai/de/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "fr",
          href: "https://remaker.ai/fr/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "pt",
          href: "https://remaker.ai/pt/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "es",
          href: "https://remaker.ai/es/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "zh",
          href: "https://remaker.ai/zh/tattoo-simulator/",
        },
        {
          rel: "alternate",
          hreflang: "x-default",
          href: "https://remaker.ai/tattoo-simulator/",
        },
      ]
    }
  },
  data() {
    return {
      aLiId: 'web-ai-tattoo',
      lan: this.$i18n.locale,
      canvasDataUrl: '',
      // 步骤控制
      currentStep: 1,
      stepLabels: [
        this.$t('tryTattoo.stepLabels[0]'),
        this.$t('tryTattoo.stepLabels[1]'),
        this.$t('tryTattoo.stepLabels[2]')
      ],

      // 图像数据
      images: [null, null], // [人物照片, 纹身图案]
      personImageElement: null, // 人物照片的HTML <img>元素，用于AI分析

      // AI相关
      isLoading: true, // 控制加载动画
      statusText: this.$t('tryTattoo.statusText.loadingModel'), // 加载提示文本
      imageSegmenter: null, // MediaPipe的AI图像分割器实例
      skinMaskImage: null, // AI生成的皮肤区域蒙版

      // 画布相关
      fabricCanvas: null, // Fabric.js的Canvas对象
      resizeHandler: null, // 窗口resize事件处理函数
      
      // 演示模态框控制
      showDemoPanel: false, // 控制演示模态框显示
      demoImagesCount: 14, // 演示图片数量
      demoImagesLoaded: [], // 跟踪演示图片的加载状态
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    // 检查设备类型
    isMobileDevice() {
      if (typeof window === 'undefined') return false;
      return window.innerWidth <= 768;
    },
  },
  async mounted() {
    this.demoImagesLoaded = Array(this.demoImagesCount).fill(false);

    try {
      await this.initializeAI();
    } catch (error) {
      this.$message.error({
        message: this.$t('tryTattoo.statusText.modelLoadFailed'),
        duration: 3000
      })
    }
    
    // 检查URL参数中是否有纹身图片
    const tattooParam = this.$route.query.tattoo;
    if (tattooParam) {
      try {
        const tattooUrl = decodeURIComponent(tattooParam);
        // 将纹身URL设置到第一个图像中（现在是images[0]，在第一步选择）
        this.$set(this.images, 0, tattooUrl);
        // 如果有纹身图片参数，仍然停留在第一步
        sendAli(this.aLiId, 'try_tattoo_with_param');
      } catch (error) {
        console.error("Error processing tattoo URL parameter:", error);
      }
    }

    // 添加滚动监听器，控制回到顶部按钮的显示和隐藏
    let topDom = this.isMobile ? window : document.querySelector('.content-area');
    topDom.addEventListener('scroll', () => {
      const backToTopButton = document.getElementById('remaker-back-to-top');
      let topDomScroll;
      if (this.isMobile) {
        topDomScroll = window.scrollY;
      } else {
        topDomScroll = document.querySelector('.content-area').scrollTop;
      }
      if (backToTopButton) {
        if (topDomScroll > 1200) {
          backToTopButton.style.display = 'block';
        } else {
          backToTopButton.style.display = 'none';
        }
      }
    });

    // FAQ面板的点击事件处理
    const faqPanel = document.querySelector('.remaker-container-faq-panel');
    if (faqPanel) {
      faqPanel.style.display = "block";
    }
    var acc = document.getElementsByClassName("remaker-container-faq-accordion");
    for (var i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
        } else {
          panel.style.display = "block";
        }
      });
    }
    
    // 组件挂载后，立即开始初始化AI模型
    try {
      await this.loadMediaPipeLibrary();
      await this.initializeAI();
    } catch (error) {
      this.statusText = this.$t('tryTattoo.statusText.modelLoadFailed');
    }
  },
  beforeDestroy() {
    // 清理window的resize事件监听
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    // 清理canvas对象
    if (this.fabricCanvas) {
      this.fabricCanvas.dispose();
      this.fabricCanvas = null;
    }
  },
  methods: {
    scrollToAnchor(id) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    },
    scrollToTop() {
      let topDom = this.isMobile ? window : document.querySelector('.content-area');
      topDom.scrollTo({ top: 0, behavior: 'smooth' });
    },
    nextStep() {
      if (this.isLoading) return; // 如果正在加载，禁止点击
      this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 1) {
        // 如果我们正要离开第三步，就必须清理画布
        if (this.currentStep === 3 && this.fabricCanvas) {
          // 移除窗口resize事件监听
          if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
            this.resizeHandler = null;
          }
          // 清理画布
          this.fabricCanvas.dispose();
          this.fabricCanvas = null;
          // 清理画布数据URL
          this.canvasDataUrl = null;
        }
        this.currentStep--;
      }
    },

    /**
     * 动态加载 MediaPipe 库
     */
    async loadMediaPipeLibrary() {
      // 如果已经加载过，直接返回
      if (window.MP_ImageSegmenter && window.MP_FilesetResolver) {
        return;
      }

      this.statusText = this.$t('tryTattoo.statusText.loadingLibrary');

      return new Promise((resolve, reject) => {
        // 创建script标签动态加载
        const script = document.createElement('script');
        script.type = 'module';
        script.innerHTML = `
          import { ImageSegmenter, FilesetResolver } from 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
          window.MP_ImageSegmenter = ImageSegmenter;
          window.MP_FilesetResolver = FilesetResolver;
          window.mediaPipeLoaded = true;
        `;

        script.onerror = () => {
          console.log('MediaPipe library failed to load.');
          this.statusText = this.$t('tryTattoo.statusText.libraryLoadFailed');
          sendAli(this.aLiId, 'try_tattoo_library_load_failed');
          reject(new Error('MediaPipe library failed to load'));
        };

        document.head.appendChild(script);

        // 轮询检查是否加载完成
        const loadStartTime = Date.now();
        const checkLoaded = () => {
          if (window.mediaPipeLoaded && window.MP_ImageSegmenter && window.MP_FilesetResolver) {
            this.statusText = this.$t('tryTattoo.statusText.initializingModel');
            resolve();
          } else if (Date.now() - loadStartTime > 15000) {
            this.statusText = this.$t('tryTattoo.statusText.libraryLoadFailed');
            sendAli(this.aLiId, 'try_tattoo_library_load_failed');
            reject(new Error('MediaPipe library load timed out'));
          } else {
            setTimeout(checkLoaded, 100);
          }
        };

        checkLoaded();
      });
    },

    /**
     * 初始化 MediaPipe 图像分割模型
     */
    async initializeAI() {
      // 1. 如果模型实例已缓存，直接使用并返回
      if (cachedSegmenter) {
        this.imageSegmenter = cachedSegmenter;
        this.isLoading = false; // 几乎瞬间完成
        return;
      }

      // 2. 如果正在初始化中，等待并使用结果
      if (initializationPromise) {
        this.isLoading = true;
        this.statusText = this.$t('tryTattoo.statusText.loadingModel');
        try {
          this.imageSegmenter = await initializationPromise;
        } finally {
          this.isLoading = false;
        }
        return;
      }

      // 3. 如果是首次加载，执行完整的初始化流程
      this.isLoading = true;
      this.statusText = this.$t('tryTattoo.statusText.loadingModel');

      initializationPromise = new Promise(async (resolve, reject) => {
        try {
          await this.loadMediaPipeLibrary(); // 调用依赖的加载方法

          if (!window.MP_ImageSegmenter || !window.MP_FilesetResolver) {
            throw new Error('MediaPipe dependencies are not loaded.');
          }

          const vision = await window.MP_FilesetResolver.forVisionTasks(
              "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm"
          );
          const segmenter = await window.MP_ImageSegmenter.createFromOptions(vision, {
            baseOptions: {
              modelAssetPath: "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_multiclass_256x256/float32/latest/selfie_multiclass_256x256.tflite",
              delegate: "CPU",
            },
            runningMode: "IMAGE",
            outputCategoryMask: true,
          });

          cachedSegmenter = segmenter; // 缓存结果
          this.imageSegmenter = segmenter;
          resolve(segmenter);

        } catch (error) {
          initializationPromise = null; // 失败时重置，允许下次重试
          reject(error);
        }
      });

      try {
        await initializationPromise;
      } finally {
        this.isLoading = false;
      }
    },

    async getUserEmit() {
      // this.loadingUser = true;
      const resp = await getUserInfoAPI();
      this.loadingUser = false;

      if (resp && resp.code === ResponseCode.SUCCESS) {
        let obj = JSON.parse(localStorage.getItem("userInfo"));
        obj.five_star = resp.data.five_star;
        obj.email = resp.data.email;
        obj.payment = resp.data.payment;
        // obj.credits = resp.data.credits - resp.data.freeze_credits;
        obj.day_sign_new = resp.data.day_sign_new;
        // obj.day_sign_credits = resp.data.day_sign_credits;

        // 积分
        let current_credit = resp.data.credits;
        let freeze_credit = resp.data.freeze_credits;
        let sign_credit = resp.data.day_sign_credits;


        // 前端展示签到积分
        let display_sign_credit = 0;
        display_sign_credit = sign_credit - freeze_credit;
        // 有可能免费积分不够扣除
        if (display_sign_credit < 0) {
          display_sign_credit = 0;
        }

        // 前端展示当前积分
        let display_current_credit = current_credit;
        // 免费积分不够，使用当前积分来扣除
        if (sign_credit - freeze_credit < 0) {
          display_current_credit =
              current_credit - (freeze_credit - sign_credit);
        }
        // 有可能跨天的时候，免费积分没了，但是用户冻结积分还没有真正扣除，这个时候归零就行。后端也是同样的逻辑
        if (display_current_credit < 0) {
          display_current_credit = 0;
        }

        let isDay = true; //是否能使用每日积分

        if (isDay) {
          obj.credits = display_current_credit;
        } else {
          obj.credits = current_credit - freeze_credit;
        }

        obj.day_sign_credits = display_sign_credit;

        obj.ifBuyFirst = resp.data.discount_plans[this.firstCode];
        localStorage.setItem("userInfo", JSON.stringify(obj));
        this.$store.commit("setUserInfo", obj);

        // 获取user-key
        const data = {
          loginType: obj.loginType,
          userId: resp.data.user_id,
          email: resp.data.email,
        };
        const result = await getUserKeyAPI(data);
        if (result.code === ResponseCode.SUCCESS) {
          // 调用 KodePay 的注册逻辑
          window.KodePay.register_login_information(result.data.user_key);
        }
      }
      //隐藏index中的loading
      if (document.getElementById("loadingMask")) {
        document.getElementById("loadingMask").remove();
      }

      return resp; // 返回响应，以便使用 Promise 链
    },

    /**
     * 计算画布的最佳尺寸
     * @private
     */
    _getCanvasDimensions() {
      const wrapper = this.$refs.canvasWrapper;
      if (!wrapper) return { width: 500, height: 500 }; // Fallback
      
      const containerWidth = wrapper.clientWidth;
      const maxWidth = this.isMobileDevice ? containerWidth : Math.min(containerWidth, 800);

      let width = maxWidth;
      let height = 500; // Default height

      if (this.personImageElement && this.personImageElement.naturalWidth > 0) {
        const scale = maxWidth / this.personImageElement.naturalWidth;
        height = Math.round(this.personImageElement.naturalHeight * scale);

        if (height > 600) {
          const aspectRatio = this.personImageElement.naturalWidth / this.personImageElement.naturalHeight;
          height = 600;
          width = Math.round(height * aspectRatio);
        }
      }
      
      return { width, height };
    },

    /**
     * 初始化 Fabric.js 画布
     */
    initializeCanvas() {
      this.$nextTick(() => {
        if (!this.$refs.canvasWrapper || this.fabricCanvas) return;

        const { width, height } = this._getCanvasDimensions();

        this.fabricCanvas = new window.fabric.Canvas('fabric-canvas', {
          width: width,
          height: height,
        });

        if (this.images[1]) {
          window.fabric.Image.fromURL(this.images[1], (img) => {
            this.fabricCanvas.setBackgroundImage(img, this.fabricCanvas.renderAll.bind(this.fabricCanvas), {
              scaleX: width / img.width,
              scaleY: height / img.height,
            });
          }, { crossOrigin: 'anonymous' });
        }

        this.resizeHandler = this.debounce(() => this.resizeCanvas(), 250);
        window.addEventListener('resize', this.resizeHandler);
      });
    },

    /**
     * 窗口大小改变时重新调整画布大小
     */
    resizeCanvas() {
      if (!this.fabricCanvas || !this.$refs.canvasWrapper || !this.personImageElement) return;

      const { width, height } = this._getCanvasDimensions();

      // 保存纹身对象的相对位置和变换
      const tattooObject = this.fabricCanvas.getObjects().find(obj => obj !== this.skinMaskImage);
      let tattooData = null;

      if (tattooObject) {
        const oldWidth = this.fabricCanvas.width;
        const oldHeight = this.fabricCanvas.height;
        tattooData = {
          left: tattooObject.left / oldWidth,
          top: tattooObject.top / oldHeight,
          scaleX: tattooObject.scaleX,
          scaleY: tattooObject.scaleY,
          angle: tattooObject.angle
        };
      }

      // 设置新的画布尺寸
      this.fabricCanvas.setWidth(width);
      this.fabricCanvas.setHeight(height);

      // 重新设置背景图像
      if (this.images[1]) {
        window.fabric.Image.fromURL(this.images[1], (img) => {
          this.fabricCanvas.setBackgroundImage(img, this.fabricCanvas.renderAll.bind(this.fabricCanvas), {
            scaleX: width / img.width,
            scaleY: height / img.height,
          });
        }, { crossOrigin: 'anonymous' });
      }

      // 重新设置皮肤蒙版
      if (this.skinMaskImage) {
        this.skinMaskImage.set({
          scaleX: width / this.skinMaskImage.width,
          scaleY: height / this.skinMaskImage.height,
          left: 0,
          top: 0,
        });
      }

      // 恢复纹身对象
      if (tattooData && tattooObject) {
        tattooObject.set({
          left: tattooData.left * width,
          top: tattooData.top * height,
          scaleX: tattooData.scaleX,
          scaleY: tattooData.scaleY,
          angle: tattooData.angle,
        });
      }

      this.fabricCanvas.renderAll();
    },

    /**
     * 简单的防抖函数，避免频繁触发resize事件
     */
    debounce(func, wait) {
      let timeout;
      return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },
    loginEmit() {
      eventBus.$emit("loginEmitBus");
    },
    // 第二步的下一步按钮
    async processPersonAndNext() {
      if (!this.getUserInfo.token) {
        // 如果用户未登录，提示登录
        this.$message ({
          message: this.$t('tryTattoo.errors.loginRequired'),
          type: 'warning',
          duration: 3000
        });
        this.loginEmit()
        return
      }
      this.statusText = this.$t('tryTattoo.statusText.processing');
      this.isLoading = true;
      // 等待 DOM 更新，让加载动画先显示出来
      await sleep(0);
      try {
        // 分离皮肤和衣服
        await this.segmentAndApplyMask();
        this.currentStep++;
        this.$nextTick(() => {
          this.scrollToAnchor('step-indicator');
        });
        sendAli(this.aLiId, 'try_tattoo_preview_result');
      } catch (error) {
        sendAli(this.aLiId, 'try_tattoo_segmentation_failed', { error: error.message });
        this.$message({
          message: this.$t('tryTattoo.errors.skinAnalysisFailed'),
          type: 'error',
          duration: 3000
        });
      } finally {
        this.isLoading = false;
      }
    },

    // AI分割图像，创建皮肤蒙版
    async segmentAndApplyMask() {
      if (!this.imageSegmenter || !this.personImageElement) {
        throw new Error("AI model or person image not loaded");
      }

      try {
        const segmenterResult = await this.imageSegmenter.segment(this.personImageElement);
        const mask = segmenterResult.categoryMask;

        const maskCanvas = document.createElement('canvas');
        maskCanvas.width = mask.width;
        maskCanvas.height = mask.height;
        const maskCtx = maskCanvas.getContext('2d');
        const imageData = maskCtx.createImageData(mask.width, mask.height);
        const maskData = mask.getAsUint8Array();

        for (let i = 0, j = 0; i < maskData.length; i++, j += 4) {
          const category = maskData[i];
          // 类别 2:身体皮肤, 3:脸部皮肤
          if (category === 2 || category === 3) {
            imageData.data[j] = 255; imageData.data[j + 1] = 255; imageData.data[j + 2] = 255; imageData.data[j + 3] = 255; // 白色
          } else {
            imageData.data[j + 3] = 0; // 透明
          }
        }
        maskCtx.putImageData(imageData, 0, 0);

        this.skinMaskImage = new window.fabric.Image(maskCanvas, {
          absolutePositioned: true
        });

      } catch (error) {
        throw error;
      }
    },

    /**
     * 统一处理图片上传（包括点击和拖拽）
     */
    handleImageUpload(step, file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageUrl = e.target.result;

        if (step === 1) { // --- 处理纹身图案 ---
          this.$set(this.images, 0, imageUrl);
        }

        else if (step === 2) { // --- 处理人物照片 ---
          this.$set(this.images, 1, imageUrl);
          // 创建<img>元素供AI分析
          this.personImageElement = new Image();
          this.personImageElement.src = imageUrl;
        }
      };
      reader.readAsDataURL(file);
    },

    /**
     * 将纹身图案添加到 Fabric 画布上
     */
    async addTattooToCanvas() {
      if (!this.fabricCanvas || !this.images[0]) return;

      // 检查皮肤蒙版是否存在，如果不存在，尝试重新生成
      if (!this.skinMaskImage && this.personImageElement && this.imageSegmenter) {
        try {
          // 先执行皮肤分割，完成后再添加纹身
          await this.segmentAndApplyMask();
          // 如果执行成功，继续添加纹身
        } catch (err) {
          this.$message({
            message: this.$t('tryTattoo.errors.tattooDisplayFailed'),
            type: 'error',
            duration: 3000
          })
          return; // 出错时直接返回
        }
      }

      // 如果经过上面的处理仍然没有皮肤蒙版，则不继续处理
      if (!this.skinMaskImage) {
        this.$message({
          message: this.$t('tryTattoo.errors.noSkinMask'),
          type: 'error',
          duration: 3000
        })
        return;
      }

      // 自定义旋转控制点图标
      if (!window.rotateIcon) {
        // 创建旋转图标的SVG
        const rotateIconSvg = `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" fill="#4a90e2" stroke="#ffffff" stroke-width="2"/>
            <path d="M12,6 A6,6 0 1,0 18,12" stroke="#ffffff" stroke-width="2" fill="none"/>
            <polygon points="12,3 9,7 15,7" fill="#ffffff"/>
          </svg>
        `;
        
        // 创建Image对象并缓存
        window.rotateIcon = new Image();
        window.rotateIcon.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(rotateIconSvg);
      }
      
      // 应用自定义控制点
      if (!this._customControlsApplied) {
        // 自定义旋转控制点
        fabric.Object.prototype.controls.mtr.render = function(ctx, left, top, styleOverride, fabricObject) {
          const size = this.cornerSize;
          ctx.save();
          ctx.translate(left, top);
          ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
          ctx.drawImage(window.rotateIcon, -size, -size, size * 2, size * 2);
          ctx.restore();
        };
        
        // 自定义控制点尺寸
        fabric.Object.prototype.controls.mtr.cornerSize = 12;
        
        // 自定义旋转控制点的偏移距离
        fabric.Object.prototype.controls.mtr.offsetY = -30;
        
        // 不显示旋转控制点到对象的连接线
        fabric.Object.prototype.controls.mtr.withConnection = true;
        
        this._customControlsApplied = true;
      }

      window.fabric.Image.fromURL(this.images[0], (tattooImg) => {
        // 为皮肤蒙版设置正确的缩放和位置
        this.skinMaskImage.set({
          scaleX: this.fabricCanvas.width / this.skinMaskImage.width,
          scaleY: this.fabricCanvas.height / this.skinMaskImage.height,
          left: 0,
          top: 0,
        });

        tattooImg.set({
          left: this.fabricCanvas.width / 3,
          top: this.fabricCanvas.height / 3,
          scaleX: 0.25,
          scaleY: 0.25,
          // 核心效果1: 混合模式，实现融合
          globalCompositeOperation: 'multiply',
          // 核心效果2: 使用皮肤蒙版进行裁剪
          clipPath: this.skinMaskImage,
          hasControls: true,
          cornerColor: '#4a90e2',
          cornerSize: 12,
          transparentCorners: false,
          borderColor: '#4a90e2',
          cornerStyle: 'circle',
          cornerStrokeColor: '#ffffff',
          controlsAboveOverlay: true,
        });
        this.fabricCanvas.add(tattooImg);
        this.fabricCanvas.setActiveObject(tattooImg);
        this.fabricCanvas.renderAll();
      }, { crossOrigin: 'anonymous' });
    },

    triggerUpload(step) {
      this.$refs[`fileInput${step}`].click();
    },
    handleFileChange(step, event) {
      const file = event.target.files[0];
      if (file) {
        this.handleImageUpload(step, file);
      }
    },
    handleDrop(step, event) {
      const file = event.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        this.handleImageUpload(step, file);
      }
    },
    resetImage(step) {
      if (step === 1) {
        // 重置纹身图片
        this.$set(this.images, 0, null);
        // 如果已经在画布上显示了纹身，需要移除它
        if (this.fabricCanvas) {
          const objects = this.fabricCanvas.getObjects('image');
          if (objects.length > 0) {
            this.fabricCanvas.remove(objects[objects.length - 1]);
            this.fabricCanvas.renderAll();
          }
        }
      } else if (step === 2) {
        // 重置人物照片
        this.$set(this.images, 1, null);
        this.personImageElement = null;
        this.skinMaskImage = null;
        if (this.fabricCanvas) {
          this.fabricCanvas.dispose();
          this.fabricCanvas = null;
        }
      }
    },
    async downloadImage() {
      if (!this.fabricCanvas) return;
      sendAli(this.aLiId, 'try_tattoo_download_image');

      const dataUrl = this.fabricCanvas.toDataURL({ format: 'png', multiplier: 3 });
      this.canvasDataUrl = dataUrl;
      
      try {
        const blob = await (await fetch(dataUrl)).blob();
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.download = `${Math.floor(Math.random() * 10000)}${Date.now()}.png`;
        link.href = url;

        // Appending to body is a good practice for cross-browser compatibility
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the link and revoking the object URLs
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

      } catch (error) {
        this.$message({
          message: this.$t('tryTattoo.errors.downloadFailed'),
          type: 'error',
          duration: 3000
        })
      }
    },

    /**
     * 等待模型加载完成后初始化画布
     */
    async waitForModelAndInitCanvas() {
      try {
        // 等待模型加载完成
        while (this.isLoading) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
        
        // 确保有人物图像
        if (!this.personImageElement && this.images[1]) {
          this.personImageElement = new Image();
          this.personImageElement.src = this.images[1];
          // 等待图像加载
          await new Promise((resolve, reject) => {
            this.personImageElement.onload = resolve;
            this.personImageElement.onerror = reject;
          });
        }
        
        // 模型加载完成后初始化画布
        this.initCanvasAndAddTattoo();
      } catch (error) {
        this.$message({
          message: this.$t('tryTattoo.errors.initializationFailed'),
          type: 'error',
          duration: 3000
        })
      }
    },

    /**
     * 初始化画布并添加纹身的统一方法
     */
    initCanvasAndAddTattoo() {
      if (!this.fabricCanvas) {
        this.initializeCanvas();
      }
      this.$nextTick(() => {
        this.addTattooToCanvas();
        // 完成后关闭加载动画
        this.isLoading = false;
        // 更新画布数据URL
        if (this.fabricCanvas) {
          this.canvasDataUrl = this.fabricCanvas.toDataURL({ format: 'png', multiplier: 3 });
        }
      });
    },
    
    /**
     * 分享当前生成的纹身效果图
     */
    share() {
      if (!this.canvasDataUrl) {
        // 如果没有画布数据，先生成
        this.canvasDataUrl = this.fabricCanvas.toDataURL({ format: 'png', multiplier: 3 });
      }
      sendAli(this.aLiId, "try_tattoo_share", this.canvasDataUrl);
    },

    /**
     * 选择演示图片作为人物照片
     * @param {number} imageNumber - 演示图片编号 (1-14)
     */
    selectDemoImage(imageNumber) {
      this.statusText = null
      this.isLoading = true; // 开始加载状态
      this.closeDemoPanel();
      const imageUrl = `https://remaker.ai/userspace/ai-tattoo-demo/try-on/${imageNumber}.webp`;
      
      // 第二步使用演示图片作为人物照片
      this.$set(this.images, 1, imageUrl);
      
      // 创建<img>元素供AI分析
      this.personImageElement = new Image();
      this.personImageElement.crossOrigin = "anonymous"; // 解决CORS问题，允许AI分析
      this.personImageElement.src = imageUrl;
      this.personImageElement.onload = () => {
        // 记录事件
        sendAli(this.aLiId, 'try_tattoo_select_demo_image', { demoImageId: imageNumber });
        this.isLoading = false;
      };
      this.personImageElement.onerror = () => {
        this.$message({
          message: this.$t('tryTattoo.errors.imageLoadFailed'),
          type: 'error',
          duration: 3000
        })
        this.isLoading = false;
      };
    },
    
    toggleDemoPanel() {
      this.showDemoPanel = !this.showDemoPanel;
      if (this.showDemoPanel) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    closeDemoPanel() {
      this.showDemoPanel = false;
      document.body.style.overflow = '';
    },
    onDemoImageLoad(index) {
      this.$set(this.demoImagesLoaded, index, true);
    },
  },
  watch: {
    currentStep(newStep) {
      if (newStep === 3) {
        if (this.isLoading) {
          this.waitForModelAndInitCanvas();
        } else {
          this.initCanvasAndAddTattoo();
        }
        // 在进入第三步时，生成一次画布图像
        this.$nextTick(() => {
          if (this.fabricCanvas) {
            this.canvasDataUrl = this.fabricCanvas.toDataURL({ format: 'png', multiplier: 3 });
          }
        });
      }
    }
  }
};
